import { BaseService } from "./baseService";
import httpRequest from "./index";
import type { ShippingServiceProviderConfig } from "@zhihaoscm/entity";

export class ServiceProviderService extends BaseService<unknown, unknown, unknown, unknown> {
    /**
     * 查询服务商配置
     * */
    public async configFind(): Promise<ShippingServiceProviderConfig[]> {
        const { data } = await this.service.get(`${this.path}/config/find`);
        return data;
    }
}

export const serviceProviderService = new ServiceProviderService("/service-provider", httpRequest);
